import { render, staticRenderFns } from "./HistoryRelance.vue?vue&type=template&id=06c93108&"
import script from "./HistoryRelance.vue?vue&type=script&lang=js&"
export * from "./HistoryRelance.vue?vue&type=script&lang=js&"
import style0 from "./HistoryRelance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports